import React from 'react';
import { MasterLayout } from 'layout';
import { TongHop } from 'modules/handle-letters';

export default class TongHopDonTreHanGiaiQuyet extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      dataThamSo: []
    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <TongHop routerName={this.props.route.name} param={this.props.params} />
      </MasterLayout>
    );
  }
};


// WEBPACK FOOTER //
// ./src/components/pages/thong-ke-bao-cao/TongHopDonTreHanGiaiQuyet.jsx